import React from "react";
const ExperienceCard = ({ theme, icon, title, des }) => {
  return (
    <div>
      <div className="flex items-center gap-2 lgl:gap-6 max-w-[460px]">
        <div
          className={`${
            theme === "dark"
              ? "text-darkTextColor border-darkLineColor"
              : "text-lightTextColor border-lightLineColor"
          } border-2 rounded-full p-3 text-[20px] lgl:text-[30px] flex justify-center items-center`}
        >
          {icon}
        </div>

        <div className="flex flex-col gap-1">
          <h3
            className={`${
              theme === "dark" ? "text-darkTextColor" : "text-lightTextColor"
            } text-xl xl:text-2xl font-bold`}
          >
            {title}
          </h3>
          <p
            className={`${
              theme === "dark"
                ? "text-darkTextDesignColor font-light"
                : "text-lightTextExtra font-normal opacity-90"
            } text-sm lgl:text-xl`}
          >
            {des}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ExperienceCard;
